import {SpecificationsModel} from "../models/view/specificationsModel";
import {useProductVariables} from "./useProductVariables";
import {useSuspenseQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {SpecificationType} from "../definitions/types";

export const useSpecificationQuery = () => {
    const {variables} = useProductVariables();

    const {data} = useSuspenseQuery(contentService.product.specifications, {
        errorPolicy: 'all',
        variables
    });

    return {model: new SpecificationsModel(data?.product?.specifications?.specifications.filter((specification): specification is SpecificationType => specification !== null) ?? [] as SpecificationType[])};
}